import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { RisksHttpClient, RiskResponse } from '@omnea-app/risks/risksHttpClient'

export type GetRiskSettingsResponse = RiskResponse<'/settings', 'get'>

export const getRiskSettingsQueryKey = 'getRiskSettings'

const useGetRiskSettingsQuery = () => {
  const { getToken } = useAuthenticatedUser()
  return {
    queryKey: [getRiskSettingsQueryKey],
    queryFn: async () => {
      const apiClient = new RisksHttpClient({ authorization: await getToken() })
      const { data, error } = await apiClient.GET('/settings')
      throwIfApiError(error)
      return data
    },
  }
}

export const useGetRiskSettingsSuspense = () => {
  return useSuspenseQuery<GetRiskSettingsResponse['data'], GetRiskSettingsResponse['error']>(useGetRiskSettingsQuery()).data
}
export const useGetRiskSettings = () => {
  return useQuery(useGetRiskSettingsQuery())
}
